import { Seo } from "@/seo/Seo";
import { Container } from "@/components/common/Container";
import { AnimatedHeading } from "@/components/common/AnimatedHeading";
import { Reveal } from "@/components/common/Reveal";
import { CtaButton } from "@/components/common/CtaButton";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" path="/404" noindex />
      <section className="relative flex min-h-[90vh] items-center overflow-hidden">
        <div className="pointer-events-none absolute inset-0 -z-10">
          <div className="absolute left-1/2 top-1/3 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-primary/[0.08] blur-[120px]" />
          <div className="absolute inset-0 bg-grid opacity-60" />
        </div>
        <Container className="text-center">
          <Reveal>
            <p className="font-mono text-sm uppercase tracking-[0.2em] text-accent">
              Error 404
            </p>
          </Reveal>
          <AnimatedHeading
            lines={["This page took", "an unexpected turn."]}
            className="mx-auto mt-5 max-w-3xl font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-foreground sm:text-5xl lg:text-6xl"
          />
          <Reveal delay={0.15}>
            <p className="mx-auto mt-6 max-w-md text-lg text-muted-foreground">
              The page you&apos;re looking for doesn&apos;t exist or has moved.
              Let&apos;s get you back on track.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <CtaButton to="/" withArrow magnetic data-testid="notfound-home-cta">
                Back to home
              </CtaButton>
              <CtaButton to="/contact" variant="outline">
                Contact us
              </CtaButton>
            </div>
          </Reveal>
        </Container>
      </section>
    </>
  );
}
